import api from './api';

export const getFeatureFlags = async () => {
  const response = await api.get('/feature-flags/');
  return response.data;
};
